import { Flex, FlexProps } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { FaBuilding } from "react-icons/fa";

interface Card2HorizontalProps extends FlexProps {
  name: string;
  complete: boolean;
  description?: string;
  onClick: any;
  icon?: any;
  bg?: string;
}

function Card2Horizontal({
  name,
  description,
  complete,
  onClick,
  icon,
  bg,
  ...rest
}: Card2HorizontalProps) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      onClick={onClick}
      flexDir="column"
      bg="white"
      rounded="16px"
      p="24px"
      cursor="pointer"
      _hover={{
        boxShadow: "0 0 32px rgba(0,0,0,.1)",
      }}
      {...rest}
    >
      <Flex>
        <Flex
          w="50px"
          h="50px"
          rounded="50%"
          justifyContent="center"
          alignItems="center"
          bg={bg ? bg : complete ? colors.green100 : colors.orange100}
        >
          {!icon ? (
            <FaBuilding
              fontSize="18px"
              color={complete ? colors.green : colors.orange}
            />
          ) : (
            icon
          )}
        </Flex>
      </Flex>
      <Flex mt="14px" fontSize="14px" textAlign="center">
        {name}
      </Flex>
      {description ? (
        <Flex mt="14px" fontSize="12px" fontWeight="bold" textAlign="center">
          {description}
        </Flex>
      ) : null}
    </Flex>
  );
}

export default Card2Horizontal;
